<app-dialog-base [showLoadingSpinner]="uiState === uiStateEnumForTemplate.ShowLoading">
  <span dialog-title>Edit Notification Settings</span>

  <ng-container dialog-content>
    <form [formGroup]="notificationSettingsForm">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Draw Notifications Start Time</mat-label>
        <input matInput data-testid="notification-start-time-input"
               placeholder="Enter time notifications should start"
               formControlName="notificationsBeginTime">
        <mat-hint>Enter military time (e.g., 14:00 = 2pm, 07:00 = 7am)</mat-hint>
        <mat-error data-testid="notification-start-time-error"
                   *ngIf="(notificationsBeginTimeControl.dirty || notificationsBeginTimeControl.touched) && notificationsBeginTimeControl.errors">
          Required format: HH:MM (24-hour time)
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width margin-top-large">
        <mat-label>Draw Notifications End Time</mat-label>
        <input matInput data-testid="notification-end-time-input"
               placeholder="Enter time notifications should end"
               formControlName="notificationsEndTime">
        <mat-hint>Enter military time (e.g., 14:00 = 2pm, 07:00 = 7am)</mat-hint>
        <mat-error data-testid="notification-end-time-error"
                   *ngIf="(notificationsEndTimeControl.dirty || notificationsEndTimeControl.touched) && notificationsEndTimeControl.errors">
          Required format: HH:MM (24-hour time)
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width margin-top-large">
        <mat-label>Notification Frequency (seconds)</mat-label>
        <input matInput type="number" data-testid="notification-frequency-input"
               placeholder="Enter notification frequency in seconds"
               formControlName="notificationFrequency">
        <mat-hint>3600 seconds = 1 hour, 1800 seconds = 30 minutes</mat-hint>
        <mat-error data-testid="notification-frequency-error"
                   *ngIf="(notificationFrequencyControl.dirty || notificationFrequencyControl.touched) && notificationFrequencyControl.errors">
          Required and must be greater than 0
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width margin-top-large">
        <mat-label>Notification Chunk Size</mat-label>
        <input matInput type="number" data-testid="notification-chunk-size-input"
               placeholder="Enter chunk size for notification batches"
               formControlName="notificationChunkSize">
        <mat-hint>Number of notifications to send in each batch</mat-hint>
        <mat-error data-testid="notification-chunk-size-error"
                   *ngIf="(notificationChunkSizeControl.dirty || notificationChunkSizeControl.touched) && notificationChunkSizeControl.errors">
          Required and must be greater than 0
        </mat-error>
      </mat-form-field>
    </form>
  </ng-container>

  <ng-container actions>
    <button mat-button color="primary" data-testid="submit-notification-settings-button"
            (click)="submit()">Submit</button>
  </ng-container>
</app-dialog-base>
